import { render, staticRenderFns } from "./talentGoods.vue?vue&type=template&id=be94c346&scoped=true&"
import script from "./talentGoods.vue?vue&type=script&lang=js&"
export * from "./talentGoods.vue?vue&type=script&lang=js&"
import style0 from "./talentGoods.vue?vue&type=style&index=0&id=be94c346&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be94c346",
  null
  
)

export default component.exports